import { useState, useCallback } from 'react';

// Shared collapse/expand state, persisted per-browser via localStorage so a
// panel remembers how the person left it next time they load the page.
// Each caller passes a unique key (e.g. 'spendingRecap') - collapse state
// is independent per panel. This is the same pattern NeedsAttention already
// used on its own; pulling it out here lets any panel opt in the same way.
export default function useCollapsible(key, defaultCollapsed = false) {
  const storageKey = `findash:collapsed:${key}`;
  const [collapsed, setCollapsed] = useState(() => {
    const stored = localStorage.getItem(storageKey);
    return stored === null ? defaultCollapsed : stored === 'true';
  });

  const toggle = useCallback(() => {
    setCollapsed((c) => {
      const next = !c;
      localStorage.setItem(storageKey, String(next));
      return next;
    });
  }, [storageKey]);

  return [collapsed, toggle];
}
